import Styled, { css } from 'styled-components';

const listStyles = css`
  margin: 1em 1.25em;
`;

export const UnorderedList = Styled.ul`
  ${listStyles}
`;

UnorderedList.displayName = 'UnorderedList';

export const OrderedList = Styled.ol`
  ${listStyles}
`;

OrderedList.displayName = 'OrderedList';
